// extracted by mini-css-extract-plugin
module.exports = {"editPacker":"EditPackerForm_editPacker__29Fnh","switch":"EditPackerForm_switch__1nsYH","status":"EditPackerForm_status__2OScm"};